import React, { useState, useEffect } from "react";
import ShopFormular from "./ShopFormular";
import TexteItemSideBar from "./TexteItemSideBar";

const TexteItemShop = ({ data }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Handle submission state change from ShopFormular
  const handleSubmittedChange = (submitted) => {
    setIsSubmitted(submitted);
  };

  // Check initial state on mount
  useEffect(() => {
    const formSubmitted = sessionStorage.getItem(`form-submitted-${data.slug}`);
    if (formSubmitted) {
      setIsSubmitted(true);
    }
  }, [data.slug]);

  return (
  <div id={`shopBody-${data.slug}`} className="shopBody textItemBody is-hidden">
    <div className="inhaltRow">
      <div className="linkeSpalte">
        <TexteItemSideBar data={data} />
      </div>
      <div className="rechteSpalte">
        <div className="rechteSpalte-inner">
          <div className="textItemTitle">{data.title}</div>
          <div className="popNav"></div>
          <div className="inhalt">
            <h2 className="shopBodyTitle">
              {isSubmitted ? "Danke" : "Kaufen"}
            </h2>
            <p className="shopBodyParagraph">
              {isSubmitted ? "Vielen Dank für Ihre Bestellung." : "Das will ich kaufen"}
            </p>
            <ShopFormular data={data} onSubmittedChange={handleSubmittedChange} isParentSubmitted={isSubmitted} />
          </div>
        </div>
      </div>
    </div>
    <div className="close">
      <img src="/assets/gestaltungselemente/close.svg" />
    </div>
  </div>
)};

export default TexteItemShop;
